// Testimonial section reviews carousel init
var reviewCarousel = document.querySelector('.TestimonialFooter__Reviews');
var flkty = new Flickity( reviewCarousel, {
  // options
  cellAlign: 'left',
  contain: true,
  prevNextButtons: false,
  watchCSS: true,
  adaptiveHeight: true
});

var productGalleryCarousel = document.querySelector('.product-gallery__custom-carousel');
var flkty = new Flickity(productGalleryCarousel, {
  cellAlign: 'left',
  contain: 'true',
  prevNextButtons: true,
  pageDots: true,
  initialIndex: 1,
  adaptiveHeight: true
})

/** Size guide popup in product page */
$( ".size-guide-popup__link" ).on( "click", function(e) {
  e.stopPropagation(); // Prevents the click event from bubbling up to the body
  $( ".size-guide-image" ).addClass("open")
} );

$( ".size-guide__close" ).on( "click", function(e) {
  e.stopPropagation(); // Prevents the click event from bubbling up to the body
  $( ".size-guide-image" ).removeClass("open")
} );

// Close the popup when clicking outside of it
$(document).on("click", function(e) {
  if($(e.target).closest(".size-guide-image.open .size-guide__table").length === 0) {
    $(".size-guide-image").removeClass("open");
  }
});
